module.exports = __webpack_public_path__ + "fonts/NotoSansLao-Regular.fcd505b.woff";